import React from 'react'
import WebCategoryMain from './WebCategoryMain'
import { useRouter } from 'next/router'
export default function WomansCategory(props) {
  const router = useRouter()
  return (
    <>
      <div className="mobile-women-category-header-section">
        <div className="mobile-women-category-back-alignment">
          <div className="back_details-alignment" onClick={() => router.push('/feed')}>
            <div>
              <img src="/assets/icon/left-icon.svg" alt="back-page" />
            </div>
            <p>Back</p>
          </div>
          <div className="mobile-heading-alignment">
            <h4>Woman Fashion &...</h4>
          </div>
        </div>
      </div>
      <div className="WomansCategory_page">
        <WebCategoryMain />
      </div>
    </>
  )
}
